module.exports = __webpack_public_path__ + "static/img/襄阳1.99e16a5d.jpg";